<script setup>
import { useI18n } from 'vue-i18n';

defineProps({ recipients: { type: Array, default: () => [] } });

const { t } = useI18n();
const empty = () => t('SALES.DETAIL.EMPTY_VALUE');
const value = current => current || empty();
const money = current => {
  const amount = current?.amount || current;
  if (!amount) return empty();

  const text = String(amount);
  return text.startsWith('R$') ? text : `R$ ${text}`;
};
const percentage = current =>
  current === null || current === undefined || current === ''
    ? empty()
    : `${current}%`;
const rows = recipient => [
  [
    {
      key: 'name',
      label: t('SALES.DETAIL.COMMISSION.ALLOCATIONS.NAME'),
      value: value(recipient.name || recipient.nome_empresarial),
    },
    {
      key: 'creci',
      label: t('SALES.DETAIL.COMMISSION.ALLOCATIONS.CRECI'),
      value: value(recipient.creci),
    },
  ],
  [
    {
      key: 'percentage',
      label: t('SALES.DETAIL.COMMISSION.ALLOCATIONS.SUMMARY.PERCENTAGE'),
      value: percentage(recipient.porcentagem_real),
    },
    {
      key: 'discount',
      label: t('SALES.DETAIL.COMMISSION.ALLOCATIONS.DISCOUNT'),
      value: recipient.desconto ? money(recipient.desconto) : empty(),
    },
    {
      key: 'value',
      label: t('SALES.DETAIL.COMMISSION.ALLOCATIONS.VALUE'),
      value: money(recipient.valor_real),
    },
  ],
  [
    {
      key: 'bank',
      label: t('SALES.DETAIL.COMMISSION.ALLOCATIONS.BANK'),
      value: value(recipient.nome_banco),
    },
    {
      key: 'branch',
      label: t('SALES.DETAIL.COMMISSION.ALLOCATIONS.BRANCH'),
      value: value(recipient.agencia),
    },
    {
      key: 'account',
      label: t('SALES.DETAIL.COMMISSION.ALLOCATIONS.ACCOUNT'),
      value: value(recipient.numero_conta),
    },
  ],
  [
    {
      key: 'pix',
      label: t('SALES.DETAIL.COMMISSION.ALLOCATIONS.PIX'),
      value: value(recipient.pix || recipient.chave_pix),
    },
  ],
];
</script>

<template>
  <div class="grid gap-6">
    <section
      v-for="recipient in recipients"
      :key="recipient.id || recipient.usuario_id"
      class="grid gap-6 border-t border-lais-border-soft pt-6"
    >
      <dl
        v-for="(row, index) in rows(recipient)"
        :key="`${recipient.id || recipient.usuario_id}-${index}`"
        class="grid gap-6 sm:grid-cols-[repeat(auto-fit,minmax(140px,1fr))]"
      >
        <div v-for="item in row" :key="item.key" class="min-w-0">
          <dt class="text-base font-bold leading-[22px] text-lais-text">
            {{ item.label }}
          </dt>
          <dd
            class="mt-1 min-w-[110px] break-words text-base leading-[22px] text-lais-text-muted"
          >
            {{ item.value }}
          </dd>
        </div>
      </dl>
    </section>
  </div>
</template>
